<template>
    <section
        class="rounded-2xl border border-theme-border bg-theme-card p-5 md:p-6"
    >
        <div class="flex items-start justify-between gap-3">
            <div>
                <h2 class="text-xl font-bold text-theme-base">
                    Termina de armar tu catálogo
                </h2>
                <p class="mt-1 text-sm text-theme-muted">
                    Llevas {{ doneCount }} de {{ tasks.length }}. Un catálogo
                    completo genera más confianza en tus clientes.
                </p>
            </div>
        </div>

        <ul class="mt-4 flex flex-col gap-2">
            <li v-for="task in tasks" :key="task.key">
                <span
                    v-if="task.done"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-theme-muted line-through"
                >
                    <span class="text-theme-success">✓</span>
                    {{ task.title }}
                </span>
                <router-link
                    v-else
                    :to="task.path"
                    class="flex items-center gap-3 rounded-lg border border-theme-border px-3 py-2 text-sm font-medium text-theme-base transition hover:bg-theme-hover"
                >
                    <span
                        class="h-4 w-4 flex-shrink-0 rounded-full border-2 border-theme-border"
                    ></span>
                    <span class="flex-1">{{ task.title }}</span>
                    <chevron-right-icon class="h-4 w-4 text-theme-muted" />
                </router-link>
            </li>
        </ul>

        <p v-if="trialText" class="mt-4 text-sm text-theme-muted">
            {{ trialText }}
            <button
                type="button"
                class="font-medium text-theme-primary hover:underline"
                @click="$emit('see-plans')"
            >
                Ver planes
            </button>
        </p>
    </section>
</template>

<script>
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";

export default {
    name: "CatalogPendingTasksCard",

    components: { ChevronRightIcon },

    props: {
        tasks: {
            type: Array,
            default: () => []
        },
        trialText: {
            type: String,
            default: ""
        }
    },

    computed: {
        doneCount() {
            return this.tasks.filter((task) => task.done).length;
        }
    }
};
</script>
